import { Button, Modal, Popconfirm, Space } from "antd";
import type { FC } from "react";
import type { SnippetDeploymentTarget } from "../../../types";
import type { SnippetRow } from "../types";

interface TargetsModalProps {
  snippet: SnippetRow | null;
  targets: SnippetDeploymentTarget[];
  onClose: () => void;
  onRemoveTarget: (environmentId: string, removeFromSite: boolean) => void;
}

export const TargetsModal: FC<TargetsModalProps> = ({ snippet, targets, onClose, onRemoveTarget }) => {
  return (
    <Modal
      title={`Deployment targets${snippet ? ` — ${snippet.name}` : ""}`}
      open={Boolean(snippet)}
      onCancel={onClose}
      footer={null}
    >
      {snippet && (
        <Space direction="vertical" style={{ width: "100%" }}>
          {targets.map((target) => (
            <Space key={target.id} style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
              <span>
                {target.projectName} / {target.environmentName}
              </span>
              <Space size="small">
                <Popconfirm
                  title="Remove tracking only"
                  description="The snippet stays live on this site, Loopress just stops tracking it. A future republish to this target will create a duplicate."
                  onConfirm={() => onRemoveTarget(target.environmentId, false)}
                  okText="Remove tracking"
                  cancelText="Cancel"
                >
                  <Button size="small">Remove tracking only</Button>
                </Popconfirm>
                <Popconfirm
                  title="Remove from site"
                  description={`This will delete the snippet from ${target.projectName} / ${target.environmentName} right now. This cannot be undone.`}
                  onConfirm={() => onRemoveTarget(target.environmentId, true)}
                  okText="Remove from site"
                  okButtonProps={{ danger: true }}
                  cancelText="Cancel"
                >
                  <Button size="small" danger>
                    Remove from site
                  </Button>
                </Popconfirm>
              </Space>
            </Space>
          ))}
        </Space>
      )}
    </Modal>
  );
};
